// extracted by mini-css-extract-plugin
module.exports = {"item":"tags-module--item--1NBLJ","link":"tags-module--link--38j2Y"};